export enum Permission {
  Admin = 'ADMIN',
  Manager = 'MANAGER',
  Sales = 'SALES',
  SuperUser = 'SUPER_USER',
}
